var render = function render(){var _vm=this,_c=_vm._self._c;return _c('invoice-preview',{attrs:{"invoice":_vm.invoice,"imageUrl":_vm.invoice.logo,"invoicedDateFormatted":this.formatDate(_vm.invoice.invoiced_date),"pdf":"pdf"}})
}
var staticRenderFns = []

export { render, staticRenderFns }